import React from 'react';
import { Modal } from '../../../components/ui/Modal';
import { Button } from '../../../components/ui/Button';
import { Input } from '../../../components/ui/Input';
import { Plus } from 'lucide-react';

interface CreateProjectModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (e: React.FormEvent) => void;
  projectName: string;
  onProjectNameChange: (val: string) => void;
  isCreating: boolean;
  orgName?: string;
}

export const CreateProjectModal: React.FC<CreateProjectModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  projectName,
  onProjectNameChange,
  isCreating,
  orgName,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Create New Project"
    >
      <form onSubmit={onSubmit} className="space-y-4">
        <p className="text-xs text-cf-textSecondary">
          Projects act as containers for your datastore tables and public form endpoints within {orgName || 'your organization'}.
        </p>

        <Input
          label="Project Name"
          size="xs"
          required
          value={projectName}
          onChange={(e) => onProjectNameChange(e.target.value)}
          placeholder="e.g. Marketing Landing Pages"
        />

        <div className="flex justify-end gap-2 pt-2">
          <Button
            type="button"
            variant="secondary"
            size="xs"
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="primary"
            size="xs"
            disabled={isCreating || !projectName.trim()}
            isLoading={isCreating}
            leftIcon={<Plus size={13} />}
          >
            Create Project
          </Button>
        </div>
      </form>
    </Modal>
  );
};
